import React from 'react';
import SubLayout from '../../../components/Layout/SubLayout.js';
import strings from "../../../components/Language/index.js";
import "./../tradebot.scss";
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../../components/config/api.js';
import { getToken, storeUserData } from '../../../components/Util/index.js';
import _ from 'lodash';
import $ from 'jquery';
import NoDataFound from './../../../assets/images/icons/no_data_found.svg';
import Sell from './../../../assets/images/icons/sell_white.svg';
import LoaderContext from '../../../components/Loader/LoaderContext.js';

class OrderListScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        var params_id = this.props.match.params.id;
        this.state = {
            lang: strings.getLanguage(),
            params_id: params_id,
            access_token: "",
            botLiveData: [],
            data: [],
            pair: {},
            parinames: [],
            selectedValues: [],
            is_load: true,
            isPressed: false,
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;

        if (self.state.access_token) {
            setLoading(true);
            self.setState({ data: [], pariNames: [], pair: {} });
            axios({
                method: 'GET',
                url: api.botc + this.state.params_id + "/bot-orders",
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    var parinames = [];
                    var botData = _.filter(ress.data.data, function (o, key) {
                        o.average_ = o.bot.total_usdt_qty / o.bot.total_coin_qty;
                        o.is_calculate = (o.bot.total_coin_qty > 0) ? true : false;

                        if (o.bot.pair.name) {
                            parinames.push(`"` + o.bot.pair.name + `"`);
                        }

                        return o;
                    });

                    var pair = (ress.data.data && ress.data.data[0] && ress.data.data[0].bot && ress.data.data[0].bot.pair) ? ress.data.data[0].bot.pair : {};

                    self.setState({ data: botData, pariNames: _.uniq(parinames), pair: pair });

                    if (parinames && parinames.length != 0) {
                        self.getLiveData();
                        setInterval(() => {
                            self.getLiveData();
                        }, 2000);
                    } else {
                        setLoading(false);
                    }

                } else {
                    setLoading(false);
                }
                self.setState({ is_load: false });
            }).catch(function (e) {
                self.setState({ is_load: false });
                setLoading(false);
            });
        }
    };

    getLiveData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            var API = "https://price.ctsbot.com/price?symbol=" + this.state.pair.name;
            axios({
                method: 'GET',
                url: API,
                headers: {
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress && ress.data.error == 200) {
                    var data = _.filter(self.state.data, function (o) {
                        var finalLiveData = ress.data.data;
                        if (finalLiveData) {

                            // Get Live data
                            o.liveData = finalLiveData;

                            // Ge percentage diff
                            var per = ((finalLiveData.lastPrice - o.data.price) / o.data.price);
                            o.per = (per) * 100;

                            // Get Floting profit diff
                            var X = (finalLiveData.lastPrice - o.data.price);
                            var Y = (X / o.data.price);
                            o.floating_profit = (Y * o.data.cost);
                        }
                        return o;
                    })
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                // toast.error(value[0]);
                            }
                        });
                    } else {
                        // toast.error(ress.data.message);
                    }
                }
                setTimeout(() => {
                    setLoading(false);
                });
                self.setState({ is_load: false });
            }).catch(function (e) {
                setLoading(false);
                //toast.error(e.message);
            });
        }
    };

    sellOrder(id) {
        const { setLoading } = this.context;
        var self = this;

        if (!id) {
            toast.error(strings.id_not_found);
            return false;
        }

        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'POST',
                url: api.botc + id + "/sell-order",
                data: {},
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                setLoading(false);
                if (ress.data && ress.data.error === 200) {
                    toast.success(ress.data.message);
                    self.setState({ data: [], pariNames: [], pair: {} });
                    setTimeout(() => {
                        self.getData();
                    }, 3500);
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
            }).catch(function (e) {
                setLoading(false);
                //toast.error(e.message);
            });
        }
    };

    sellAlert(id, txt) {
        var self = this;
        $.confirm({
            title: strings.confirm + '!',
            theme: 'dark',
            content: strings.are_you_sure_you + " " + txt + " " + strings.order_,
            buttons: {
                somethingElse: {
                    text: strings.SELL,
                    btnClass: 'btn-success',
                    action: function () {
                        self.sellOrder(id);
                    }
                },
                cancel: function () {
                    //close
                },
            }
        });
    };

    handleCheckboxChange = (value) => {
        if (this.state.selectedValues.includes(value)) {
            // Remove value if already selected
            this.setState({
                selectedValues: this.state.selectedValues.filter(item => item != value),
            });
        } else {
            // Add value
            this.setState({
                selectedValues: [...this.state.selectedValues, value],
            });
        }
    };

    handleSubmit = () => {
        var self = this;
        if (this.state.isPressed) {
            return false;
        }
        if (self.state.selectedValues.length == 0) {
            toast.error(strings.please_select_at_least_one_order);
            return false;
        } else {
            $.confirm({
                title: strings.confirm + '!',
                theme: 'dark',
                content: strings.are_you_sure_you_want_to_sell_all_order,
                buttons: {
                    somethingElse: {
                        text: strings.SELL,
                        btnClass: 'btn-success',
                        action: function () {
                            self.sellAllOrderSelected(self.state.selectedValues);
                        }
                    },
                    cancel: function () {
                        //close
                    },
                }
            });
        }
    };

    sellAllOrderSelected(orders) {
        const { setLoading } = this.context;
        var self = this;
        this.setState({ isPressed: true });
        if (self.state.selectedValues.length == 0) {
            toast.error(strings.id_not_found);
            return false;
        }

        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'POST',
                url: api.botc + this.state.params_id + "/sell-order-multiple",
                data: {
                    orders: orders
                },
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                setLoading(false);
                self.setState({ isPressed: false });
                if (ress.data && ress.data.error === 200) {
                    toast.success(ress.data.message);
                    self.botStartAlert(self.state.params_id, self.state.pair.name);
                    self.setState({ data: [], pariNames: [], pair: {} });
                    setTimeout(() => {
                        self.getData();
                    }, 3500);

                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
            }).catch(function (e) {
                setLoading(false);
                self.setState({ isPressed: false });
            });
        }
    };

    botStartAlert(id, txt) {
        var self = this;
        $.confirm({
            title: strings.confirm + '!',
            theme: 'dark',
            content: strings.are_you_want_to_start_bot + " " + txt + " ?",
            buttons: {
                somethingElse: {
                    text: "Yes",
                    btnClass: 'btn-success',
                    action: function () {
                        self.doStart(id);
                    }
                },
                cancel: function () {
                    //close
                },
            }
        });
    };

    doStart(id) {
        const { setLoading } = this.context;
        var self = this;
        var api_url = api.botc + id + "/start-bot";
        if (self.state.access_token && api_url) {
            self.setState({ loading: true });
            setLoading(true);
            axios({
                method: 'GET',
                url: api_url,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                setLoading(false);
                if (ress.data && ress.data.error === 200) {
                    toast.success(ress.data.message);
                    self.getData();
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                self.setState({ loading: false });
            }).catch(function (e) {
                setLoading(false);
                self.setState({ loading: false });
            });
        }
    };

    render() {

        return (
            <>
                {!this.state.is_load ?
                    <SubLayout data={{ "title": (this.state.pair && this.state.pair.name) ? this.state.pair.name + " " + strings.ai_bot_order_list : strings.AI_Bot + ' ' + strings.order_list, "pair_logo": (this.state.pair && this.state.pair.icon_url) ? this.state.pair.icon_url : '', is_pair_log: true }}>
                        <div
                            className='offset-md-4 col-md-4 common_textbox'
                            style={{ marginInline: 5, marginTop: 20, margin: "0 auto" }}
                        >
                            {this.state.data && this.state.data.length != 0 ?
                                <>
                                    <div className="list_item" style={{ padding: 0 }}>
                                        {this.state.data.map((item, i) =>
                                            <>
                                                {i != 0 ? <div className='boder_' style={{ margin: 0 }} key={200} /> : null}

                                                <div key={i + 101} className='row' style={{ margin: 0, paddingBlock: 10, paddingInline: 10, alignItems: "center", flexDirection: "row" }}>
                                                    <div className="col-2" style={{ textAlign: "center" }}>
                                                        <div className='' style={{ color: "#FFFFFF", fontSize: 12 }}>{i + 1}</div>
                                                        <div className='gray_color' style={{ fontSize: 12 }}>{strings.layer}</div>
                                                    </div>
                                                    <div className='col-2' style={{ padding: 2, textAlign: "center" }}>
                                                        <div className='' style={{ color: "#FFFFFF", fontSize: 12 }}>
                                                            {(item.data && item.data.price) ? Number.parseFloat(item.data.price).toFixed(4) : "0.00"}
                                                        </div>
                                                        <div className='gray_color' style={{ color: "#FFFFFF", fontSize: 12 }}>{strings.price}</div>
                                                    </div>
                                                    <div className='col-7' style={{ padding: 2, textAlign: "center" }}>
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <div className='gray_color' style={{ color: "#FFFFFF", fontSize: 12, marginRight: 5 }}>
                                                                {strings.PnL_per}
                                                            </div>
                                                            <div className='avg_label'>
                                                                <div className='width-fit-content avg_price'>
                                                                    <label style={{ fontSize: 12, paddingBlock: 2, paddingInline: 5 }} className={(item.per && item.per > 0) ? "text_up" : "text_down"}>
                                                                        {(item.per && item.per > 0) ? Number.parseFloat(item.per ?? 0).toFixed(2) : Number.parseFloat(item.per ?? 0).toFixed(2)}%
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='gray_color' style={{ color: "#FFFFFF", fontSize: 12 }}>{strings.floating_profit}: {Number.parseFloat(item.floating_profit ?? 0).toFixed(4)}</div>
                                                    </div>
                                                    <div className='main_content col-1' style={{ padding: 2, textAlign: "-webkit-right" }}>
                                                        <input
                                                            type="checkbox"
                                                            value={item.order_id}
                                                            checked={this.state.selectedValues.includes(item.order_id)}
                                                            onChange={() => this.handleCheckboxChange(item.order_id)}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </>
                                :
                                <div className="text-center" style={{ marginTop: 25 }}>
                                    <img src={NoDataFound} alt="CTS Bot"></img>
                                </div>
                            }

                            {
                                this.state.selectedValues.length != 0 ?
                                    <div className="" style={{ position: "fixed", zIndex: 9999999999, bottom: 0, width: "100%", backgroundColor: "#000" }}>
                                        <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                            <div className='col-12 text-center d-flex justify-content-center' style={{ margin: 10 }}>
                                                <div onClick={this.handleSubmit} className='text-center sell_btn_order_' style={{ maxWidth: 'fit-content' }}>
                                                    {
                                                        this.state.isPressed ?
                                                            <>
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                <label className='' style={{ color: "#FFFFFF", fontSize: 12, marginLeft: 3 }}>{strings.processing_}</label>
                                                            </>
                                                            :
                                                            <>
                                                                <img src={Sell} width={12} alt="" height={12} />
                                                                <label className='' style={{ color: "#FFFFFF", fontSize: 12, marginLeft: 3 }}>{strings.Sell_Selected_Order}</label>
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                    </SubLayout >
                    : null}
            </>
        );
    }
}

export default OrderListScreen;